import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {matchRoutes, useLocation, useNavigate} from 'react-router-dom'

import {Nav, INavLink} from "@fluentui/react"
import "./navbarcss.css"
import {
    makeStyles,
    shorthands,
    Tab,
    TabList,
    TabListProps,
  } from "@fluentui/react-components";

  const useStyles = makeStyles({
    root: {
      
      ...shorthands.padding("10px", "20px"),
      rowGap: "20px",
      fontFamily:"IBM Plex Sans",
    //   backgroundColor:"black"
     "@media (max-width:768px)":{
        ...shorthands.padding("10px", "0px"),
     }
    },
  });


const Navbar = (props)=>{
    const [currentLink, setCurrentLink] = useState("home")
    const navigate = useNavigate()
    const location = useLocation()
    const styles = useStyles()
    
    

   
    const handleLinkClick = (e, data)=>{
        const type = data.value
        setCurrentLink(type)
        if(type == "portfolio"){
            navigate("/")
        }else{
            navigate("/"+type)
            if (type == "about"){
            window.location.reload()
            }
        }
        

    }
    const isCurrentLink=(link)=>{
        return link == currentLink
    }
    useEffect(()=>{
        // console.log9
        if(location.pathname === "/"){
            setCurrentLink("portfolio")
        }
        if(location.pathname === "/projects"){
            setCurrentLink("projects")
        }
        if(location.pathname === "/content"){
            setCurrentLink("content")
        }
        if(location.pathname === "/about"){
            setCurrentLink("about")
        }

    },[])
    return (
        
    <div className={["ms-Grid",styles.root].join("")}>
        
            <div style={{
            "@media (max-width:768px)":{
            display:"none"
        }}} className="ms-Grid-row" >
                <div className={['ms-Grid-col ms-sm6 ms-lg6 title'].join('')} style={{padding:"10px 20px", fontSize:"200%"}}>
                    RAUFIE
                </div> 
                <div className={['ms-Grid-col ms-sm6 ms-lg6'].join('')}>
                    <TabList {...props} selectedValue={currentLink} onTabSelect={handleLinkClick}>
                        <Tab value="portfolio" style={{fontFamily:props.font}} >PORTFOLIO</Tab>
                        <Tab value="projects"  style={{fontFamily:props.font}}>PROJECTS</Tab>
                        <Tab value="content"  style={{fontFamily:props.font}}>CONTENT</Tab>
                        <Tab value="about"  style={{fontFamily:props.font}}>ABOUT</Tab>
                    </TabList>
                </div>
            </div> 
   
    </div>
 

    )
}
export default Navbar;